import React from 'react';

import { splitHighlightedText } from '@pflegia/util/common/seo-page-meta';

interface HighlightedTextProps {
  text: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({ text }) => {
  const segments = splitHighlightedText(text);
  if (!segments.some(({ highlighted }) => highlighted)) return text;

  return segments.map(({ text: segmentText, highlighted }, index) =>
    highlighted ? (
      // eslint-disable-next-line react/no-array-index-key
      <span className='text-primary' key={index}>
        {segmentText}
      </span>
    ) : (
      // eslint-disable-next-line react/no-array-index-key
      <React.Fragment key={index}>{segmentText}</React.Fragment>
    ),
  );
};

export default HighlightedText;
